import { Typography } from "@mui/material";
import { IMaterialProperties } from "mobx-stores/_models/material-inventory/material";
import { IPaperMaterialProperties } from "mobx-stores/_models/paper-inventory/paper-material";
import { IProductProperties } from "mobx-stores/_models/products/product";

export const createProductRenderOption = (product: IProductProperties) => {
  return (
    <Typography>
      <Typography component={"span"} color={"red"}>
        {product.name || ""}
      </Typography>{" "}
      {" - "}
      <Typography component={"span"} color={"#0066ff"}>
        {product.code || ""}
      </Typography>
    </Typography>
  );
};

export const createProductOptionLabel = (product: IProductProperties) => {
  return `${product.name || ""} - ${product.code || ""}` || "";
};

export const createMaterialOptionLabel = (material: IMaterialProperties) => {
  return (
    `${material.name || ""}, khổ ${material.specificationSize || ""}, dài ${
      material.specificationLength || ""
    }, dày ${material.specificationThick || ""}` || ""
  );
};

export const createPaperMaterialOptionLabel = (
  paperMaterial: IPaperMaterialProperties
) => {
  return `${
    paperMaterial.type || ""
  }, gsm ${paperMaterial.gsm?.toString()}, khổ ${
    paperMaterial.specificationSize?.toString() || ""
  }, dài ${paperMaterial.specificationLength?.toString() || ""}`;
};
